import axiosInstance from "../../axiosInstance";

const BASE_URL = "/finance/receipts";

export const getAllReceipts = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getReceiptDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const createReceipt = async (payload) => {
  const res = await axiosInstance.post(BASE_URL, payload);
  return res.data;
};

export const updateReceipt = async (id, payload) => {
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, payload);
  return res.data;
};

export const deleteReceipt = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};
